module.exports = __webpack_public_path__ + "static/media/pf.ade1f0f6.svg";